<template>
  <!-- 分类的下拉框 -->
  <div class='sp-categories-selector' :style="{'width': this.selectWidth+'px'}">
    <yxt-select
      :style="{'width': this.selectWidth+'px'}"
      @visible-change='openOrCloseSelect'
      @clear='clear'
      clearable
      :size='size'
      ref='categoriesSelector'
      v-model='classification'
      popper-class='sp-categories-select__popover'
      :placeholder='$t("pc-biz-sp-categoryse")'
    >
      <yxt-option class='sp-categories-selector__option' :value='null'>
        <yxt-tree
          ref='categoriesTree'
          class='sp-tree'
          node-key='id'
          :highlight-current='true'
          :data='categories'
          @node-click='selected'
        ></yxt-tree>
      </yxt-option>
    </yxt-select>
  </div>
</template>

<script>

import { getCategories } from './server';

export default {
  name: 'CategoriesSelector',
  props: {
    selectWidth: Number,
    size: {
      type: String,
      default: 'large'
    }
  },
  data() {
    return {
      // 分类选择的值
      classification: '',
      categoryId: '',
      categories: []
    };
  },
  computed: {},
  created() {
    getCategories().then(res => {
      res.datas.forEach(row => {
        row.children.forEach(item => {
          !item.children.length && delete item.children;
          item.lastNode = true;
        });
      });
      this.categories = res.datas;
    });
  },
  methods: {
    // 为了解决分类的滚动条的初始化问题
    openOrCloseSelect(val) {
      if (this.categoriesTreeRendered) {
        // 如果popper已经渲染过
        if (!val) {
          // popper隐藏时把横向、纵向滚动条重置
          this.categoriesPopperTreeWrap.scrollLeft = 0;
          if (this.categoriesPopperWrap) {
            this.categoriesPopperWrap.scrollTop = 0;
          }
        }
        return;
      }
      // 记录popper已经渲染过，事件只需要绑定一次
      this.categoriesTreeRendered = true;
      this.$nextTick(() => {
        this.categoriesPopperWrap = document.querySelector(
          '.sp-categories-select__popover > .yxt-scrollbar .yxt-scrollbar__wrap'
        );
        this.categoriesPopperTreeWrap = this.$refs.categoriesTree.$el.querySelector(
          '.yxt-scrollbar__wrap'
        );
        const horizontalBar = this.$refs.categoriesTree.$el.querySelector(
          '.yxt-scrollbar__bar.is-horizontal'
        );
        horizontalBar &&
        horizontalBar.addEventListener('click', event => {
          if (event && event.stopPropagation) {
            event.stopPropagation();
          } else {
            window.event.cancelBubble = true;
          }
          event.preventDefault();
          return false;
        });
      });
    },
    // 清空分类时触发
    clear() {
      this.categoryId = '';
      this.$refs.categoriesTree.setCurrentKey(null);
      this.$emit('clear');
    },
    // 选择分类
    selected(nodeData) {
      this.classification = nodeData.label;
      this.categoryId = nodeData.id; // 分类的id
      this.$refs.categoriesSelector.blur();
      this.$emit('change', nodeData.id);
    },
    // 获取当前分类ID 外部调用
    getCategoryId() {
      return this.categoryId;
    }
  }
};
</script>

<style lang='scss'>
.sp-categories-selector {
  display: inline-block;

  &__option {
    height: auto;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #fff;

    .yxt-tree-node__label {
      font-weight: 400;
    }

    .yxt-tree {
      margin-bottom: 8px;
    }

    .yxt-scrollbar__bar.is-horizontal {
      height: 10px;

      .yxt-scrollbar__thumb {
        height: 6px;
        margin-top: 4px;
      }
    }
  }
}

// 覆盖分类的滑动样式
.sp-categories-select__popover {
  .yxt-scrollbar__wrap {
    background-color: #fff;
    overscroll-behavior: auto;
  }

  .yxt-select-dropdown__list {
    padding-bottom: 0;
  }

  > .yxt-scrollbar > .is-horizontal {
    display: none;
  }
}

.sp-tree {
  width: auto !important;
}

// // 覆盖组件样式
// .sp-tree .yxt-tree-node__content {
//   height: auto;
// }
// .category-tree {
//   width:546px!important;
// }
</style>
